import React from 'react'

import {
  arrayOf, bool, node, shape, string, oneOfType, elementType,
} from 'prop-types'

import { EMPTY_ARRAY } from 'Utils/stableDefaults'

import CustomSolutionCardStep from './CustomSolutionCardStep'
import FeatureItem from './FeatureItem'

function CustomSolutionCard({
  steps = EMPTY_ARRAY,
  cardTitle = '',
  stepsTitle = '',
  features = EMPTY_ARRAY,
  featureTitle = '',
  cardDescription = '',
  Icon = null,
  Button = null,
}) {
  return (
    <article className="custom-solutions__card">
      <div className="custom-solutions__card-content">
        <div className="custom-solutions__card-header">
          <div>
            <div className="custom-solutions__card-title-container">
              {Icon && <Icon width="32" height="32" />}
              {cardTitle && (
                <h3 className="custom-solutions__card-title text-white font-weight-600">
                  {cardTitle}
                </h3>
              )}
            </div>
            {cardDescription && (
              <p className="text-light-grey cgt-legacy-text-default">
                {cardDescription}
              </p>
            )}
          </div>

          {Button && (
            <div className="card-button-desktop">
              <Button />
            </div>
          )}
        </div>

        <div className="custom-solutions__steps">
          {stepsTitle && (
            <h4 className="cgt-legacy-text-caption text-light-grey uppercase">
              {stepsTitle}
            </h4>
          )}
          <div className="custom-solutions__steps-list">
            {steps?.map((step, index) => (
              <CustomSolutionCardStep
                key={`modelry-step-${index + 1}`}
                stepNumber={step.stepNumber}
                position={step.position}
                stepTitle={step.stepTitle}
                highlightStep={step.highlightStep}
                stepDescription={step.stepDescription}
              />
            ))}
          </div>
        </div>
        <div className="custom-solutions__features">
          {featureTitle && (
            <h4 className="cgt-legacy-text-caption text-light-grey uppercase">
              {featureTitle}
            </h4>
          )}
          <ul className="custom-solutions__features-list">
            {features?.map((feature, index) => (
              <FeatureItem
                key={`modelry-feature-${index + 1}`}
                title={feature.title}
                Icon={feature.icon}
                description={feature.description}
              />
            ))}
          </ul>
        </div>

        {Button && (
          <div className="card-button-mobile">
            <Button />
          </div>
        )}
      </div>
    </article>
  )
}

CustomSolutionCard.propTypes = {
  cardTitle: string,
  stepsTitle: string,
  featureTitle: string,
  cardDescription: string,
  Icon: oneOfType([elementType, node]),
  Button: oneOfType([elementType, node]),
  steps: arrayOf(
    shape({
      highlightStep: bool,
      stepNumber: string,
      position: string,
      stepTitle: string,
      stepDescription: string,
    })
  ),
  features: arrayOf(
    shape({
      title: string,
      Icon: node,
    })
  ),
}

export default CustomSolutionCard
